import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/edi/portmapping'
import pathMap from 'src/paths/PathMap_EDI'

class PortMappingRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.PORT_MAPPING_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.PORT_MAPPING_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.PORT_MAPPING_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.PORT_MAPPING_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default PortMappingRoute
